import api from "./Api";

export const getArenas = () => api.get(`api/arenas`);
export const getArenasPorCpf = (cpf) => api.get(`api/arenas/${cpf}`);
